__turbopack_context__.v({
  "loader": "Loader-module-scss-module___e8aUW__loader",
  "loaderContent": "Loader-module-scss-module___e8aUW__loaderContent",
  "loaderLogo": "Loader-module-scss-module___e8aUW__loaderLogo",
  "loaderText": "Loader-module-scss-module___e8aUW__loaderText",
  "spin": "Loader-module-scss-module___e8aUW__spin",
  "spinner": "Loader-module-scss-module___e8aUW__spinner",
});
